import { render } from "./Biomarker_Plots.vue?vue&type=template&id=781a8f75&scoped=true"
import script from "./Biomarker_Plots.vue?vue&type=script&lang=js"
export * from "./Biomarker_Plots.vue?vue&type=script&lang=js"

import "./Biomarker_Plots.vue?vue&type=style&index=0&id=781a8f75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781a8f75"]])

export default __exports__